export const EMPTY_DRAFT = {
  type: 'post',
  attachments: [],
  post_in_communities: [],
  pinned: false,
  html_content: '',
};
